import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaAdUserLog" */ './lazyIndex'),
    { name: 'OwaAdUserLog' }
);

export const logUserAdConfigLazy: LazyAction<typeof lazyIndex.logUserAdConfig, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.logUserAdConfig);

export { getIpLoc } from './utils/getIpLoc';
